import * as React from 'react';
import { DottedProgress, GridV2 } from '@kite-js/core';
import { Box } from '@kite-js/core';
import { DottedProgressProps } from '@kite-js/core/lib/DottedProgress/DottedProgress';
import { BoxProps } from '@kite-js/core/lib/Box/Box';

export interface LoadingProps {
    isLoading: boolean;
    wrapperBox?: BoxProps;
    text?: string;
    dottedProgress: Pick<DottedProgressProps, 'size' | 'monochrome'>;
}

/**
 * show loading progress when one of dependencies is false
 *
 * @param props
 */
export const Loading: React.FC<LoadingProps> = props => {
    if (props.isLoading) {
        return (
            <Box {...props.wrapperBox} clone={true} data-cy="loading">
                <GridV2 justify="center" alignItems="center">
                    <GridV2.Item>
                        <DottedProgress {...props.dottedProgress} />
                    </GridV2.Item>
                </GridV2>
            </Box>
        );
    }

    return <>{props.children}</>;
};
